<template>
	<div v-if="hiddenCount > 0" class="sidebar-hidden-groups">
		<div class="sidebar-hidden-header">
			<EyeSlashIcon class="sidebar-hidden-icon" type="solid" />
			<span
				class="sidebar-hidden-title"
				v-t="'chat_drawer_hidden_groups_title'"
			/>
		</div>
		<p
			class="sidebar-hidden-description"
			v-t="'chat_drawer_hidden_groups_subtitle'"
		/>
		<Button class="sidebar-hidden-button" block @click="goToHiddenGroups">
			{{ $t('chat_drawer_hidden_groups_button', [hiddenCount]) }}
		</Button>
	</div>
</template>

<script>
import { getMyUser } from '@/store'
import { Button } from '@/components/common'
import { EyeSlashIcon } from '@/icons'

export default {
	name: 'SidebarHiddenGroups',
	components: { EyeSlashIcon, Button },
	computed: {
		hiddenCount() {
			return getMyUser()?.hidden_group_memberships_count ?? 0
		},
	},
	methods: {
		goToHiddenGroups() {
			this.$router.push({ name: 'hiddengroups' })
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.sidebar-hidden-groups {
	padding: 13px 18px 10px 18px;
	margin: 8px 8px 0;
	background: var(--neutral-0);
	border-radius: 14px;
}

.sidebar-hidden-header {
	display: flex;
	align-items: center;
	gap: 6px;
}

.sidebar-hidden-icon {
	font-size: 13px;
	color: var(--neutral-800);
	margin-bottom: 2px;
}

.sidebar-hidden-title {
	font-family: Avenir-Heavy;
	font-size: 13px;
	color: var(--neutral-800);
}

.sidebar-hidden-description {
	font-family: Avenir-Roman;
	font-size: 12px;
	color: var(--neutral-600);
	margin: 7px 0 12px 0;
}

.sidebar-hidden-button {
	padding: 0 16px;
	height: 38px;
	border: 1px solid var(--neutral-200);
	border-radius: 8px;
	background: var(--neutral-100);
	font-family: Avenir-Medium;
	font-size: 13px;
	color: var(--neutral-800);
	box-shadow: none;
}
</style>
<style lang="scss">
@import 'src/sass/variables';

@include overrideScheme('dark') {
	.sidebar-hidden-groups {
		background: var(--neutral-100);
	}
}
</style>
